<template>
  <div class="page-container content-430">
    <div class="search-wrap">
      <Form
        ref="formInline"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem class="sch-form-item" label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem class="sch-form-item" label="">
            <Cascader
              v-model="formValidate.classData"
              :data="gradeAndClassList"
              clearable
              change-on-select
              placeholder="请选择年级班级"
            ></Cascader>
          </FormItem>
          <FormItem class="sch-form-item" label="">
            <Cascader
              v-model="formValidate.classTypeShow"
              :data="courseTypeListData"
              clearable
              placeholder="请选择课程类型"
            ></Cascader>
          </FormItem>
          <FormItem class="sch-form-item" label="">
            <div class="select-time" @click="handleOpenTimeModal">
              <span v-if="selectTimeListStr">{{ selectTimeListStr }}</span>
              <span v-else>上课时间段</span>
              <div class="right-icon-block">
                <Icon class="arr-icon" color="#808695" type="ios-arrow-down"></Icon>
              </div>
              <div v-if="selectTimeListStr" class="right-icon-block">
                <Icon class="close-icon" color="#808695" type="md-close-circle" @click.stop="handleCloseTime"></Icon>
              </div>
            </div>
          </FormItem>
          <Button
            type="primary"
            style="margin-right: 8px"
            @click="handleSearch"
          >查询</Button>
          <Button @click="resetData">重置</Button>
        </Row>
      </Form>
    </div>
    <div class="table-title-special-430 flex justify-space_between">
      <div class="flex flexrow flexac">
        数据统计
        <Button type="primary" shape="circle" icon="md-refresh" :loading="loading" style="margin-left: 10px;" @click="getClassCoursePeriodStatisticData"></Button>
        <div style="margin-left:20px;">截止：{{ timeFont }}</div>
      </div>
      <Button
        type="primary"
        @click="handleDownload"
      >下载</Button>
    </div>
    <div class="table-wrap">
      <Table
        :columns="columnsShow"
        :data="tableList"
        :max-height="tableHeight - 140"
        :loading="loading"
        border
        show-summary
        :summary-method="handleSummary"
      >
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        show-sizer
        show-elevator
        show-total
        class="text-right mb-5 mt-5"
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="handlePage"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal v-model="showClassTimeModal" class="time-select-modal" title="选择上课时间">
      <div class="modal-content">
        <div class="left-content">上课时间：</div>
        <div class="right-content">
          <div v-for="(item,index) in selectTimeList" :key="index" class="time-select">
            <div class="time-line">
              <TimePicker
                v-model="selectTimeList[index]"
                style="margin-right: 10px;"
                :steps="[1, 5]"
                :disabled-hours="[0, 1, 2, 3, 4, 5, 23, 24]"
                hide-disabled-options
                format="HH:mm"
                type="timerange"
                placement="bottom-end"
                placeholder="请选择上课起止时间"
                @on-open-change="onTimeOpenChange"
              ></TimePicker>
              <Icon style="margin-right: 10px;" size="24" color="#2d8cf0" type="md-add-circle" @click="handleAddClassTime(index)"></Icon>
              <Icon v-if="selectTimeList.length!==1" size="24" color="#ed4014" type="md-remove-circle" @click="handleDelClassTime(index)"></Icon>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button type="primary" @click="checkTimeSelect">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="showExportModal"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelExport"
    >
      <Progress :percent="percent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelExport">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import common from '@/request/common/index.js';
import analysisCenterApi from '@/request/analysisCenter/index.js';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { checkTimeRangehasIntersection, formatTime } from '@/utils/utils';
import { weekList } from '@/utils/dictionary';
import {
  tableColumnsWidth,
  key
} from '@/assets/js/resetTableStyle';
let IntervalId;
export default {
  name: 'CourseEnrollClassSummary',
  components: {
    CascaderYearTerms
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      portOrg: -1,
      orgId: '',
      initYear: [],
      yearTerms: [],
      timeFont: '',
      gradeAndClassList: [], // 年级班级列表
      courseTypeListData: [
        {
          label: '素质课',
          expand: true,
          value: '1',
          children: [
            {
              label: '艺术',
              value: '11'
            },
            {
              label: '科技',
              value: '12'
            },
            {
              label: '体育',
              value: '13'
            },
            {
              label: '美术',
              value: '14'
            },
            {
              label: '综合实践',
              value: '15'
            }
          ]
        }, {
          label: '基础托管',
          expand: true,
          value: '2',
          children: [
            {
              label: '早托',
              value: '21'
            },
            {
              label: '午托',
              value: '22'
            },
            {
              label: '晚托',
              value: '23'
            },
            {
              label: '晚修',
              value: '24'
            }
          ]
        }],
      formValidate: {
        // termIdShow: '',
        classData: [],
        gradeId: '',
        classId: '',
        classTypeShow: []
      },
      selectTimeListTrue: [[]],
      selectTimeListTrueSearch: [],
      selectTimeList: [],
      showClassTimeModal: false,
      columns: [
        key('学校', 'schoolName', tableColumnsWidth.type4, { align: 'center' }),
        key('学期', 'yearTermName', tableColumnsWidth.type5, { align: 'center' }),
        key('年级', 'gradeName', tableColumnsWidth.type2, { align: 'center' }),
        key('班级', 'className', tableColumnsWidth.type2, { align: 'center' })
      ],
      tableList: [],
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      loading: false,
      pageSizeOpts: [10, 20, 50, 100],
      dataChange: 1,
      source: null,
      showExportModal: false,
      percent: 0, // 进度条,
      courseTypeShow: false
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState']),
    selectTimeListStr() {
      if (this.selectTimeListTrue.length === 0) {
        return '';
      }
      const strArr = [];
      this.selectTimeListTrue.forEach(item => {
        if (item && item.length === 2) {
          strArr.push(`${item[0]}-${item[1]}`);
        }
      });
      return strArr.join('、');
    },
    courseTimes() {
      if (this.selectTimeListStr) {
        return this.selectTimeListTrue.map(item => {
          return {
            beginTime: `${item[0]}:00`,
            endTime: `${item[1]}:00`
          };
        });
      } else {
        return [];
      }
    },
    timeColumnsKeyObj() {
      const splitList = [];
      this.selectTimeListTrueSearch.forEach(item => {
        if (item.length === 2) {
          splitList.push(`${item[0]}-${item[1]}`);
        }
      });
      const obj = {};
      weekList.forEach(item => {
        const list = [...splitList, '其他'];
        list.forEach(x => {
          obj[`${item.value}-${x}`] = '-';
        });
      });
      return obj;
    },
    columnsShow() {
      const splitList = [];
      this.selectTimeListTrueSearch.forEach(item => {
        if (item.length === 2) {
          splitList.push(`${item[0]}-${item[1]}`);
        }
      });
      const columnsOther = weekList.map(item => {
        const list = [...splitList, '其他'];
        const children = list.map(x => {
          return {
            title: x,
            key: `${item.value}-${x}`,
            minWidth: 150,
            align: 'center'
          };
        });
        return {
          title: item.label,
          align: 'center',
          children
        };
      });
      return [...this.columns, ...columnsOther];
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    localStorage.getItem('selectTimeListTrue') ? this.selectTimeListTrue = JSON.parse(localStorage.getItem('selectTimeListTrue')) : '';
    if (this.portOrg === 2) {
      this.orgId = this.userInfo.orgId;
      this.getGradeAndClass();
    } else {
      this.$nextTick(() => {
        this.orgId = this.schoolIdForState ? this.schoolIdForState : '';
        this.getGradeAndClass();
      });
    }
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      this.orgId = id;
      this.getGradeAndClass();
      this.resetData();
    });
  },
  methods: {
    handleCloseTime() {
      this.selectTimeListTrue = [[]];
    },
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (key === 'schoolName' || key === 'yearTermName' || key === 'gradeName') {
          sums[key] = {
            key,
            value: ' '
          };
          return;
        }
        if (key === 'className') {
          sums[key] = {
            key,
            value: '合计'
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: v || v === 0 ? v : '-'
          };
        } else {
          sums[key] = {
            key,
            value: '-'
          };
        }
      });

      return sums;
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      const params = {
        schoolId: this.orgId
      };
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
    onCascaderChange(v) {
      this.yearTerms = v;
      if (this.dataChange === 1) {
        this.handleSearch();
        this.dataChange++;
      }
    },
    //
    onTimeOpenChange(status) {
      if (status) {
        setTimeout(() => {
          const dom = document.querySelectorAll('.ivu-time-picker-cells-list');
          for (let i = 0, len = dom.length; i < len; i++) {
            dom[i].scrollTop = 0;
          }
        }, 300);
      }
    },
    handleAddClassTime(index) {
      if (this.selectTimeList.length === 5) {
        this.$Message.error('最多支持5个时间段');
        return;
      }
      const time = this.selectTimeList[index];
      let timeSelect = [];
      if (time && time.length === 2) {
        timeSelect = [time[1], time[1]];
      }
      this.selectTimeList.splice(index + 1, 0, timeSelect);
    },
    handleDelClassTime(index) {
      this.selectTimeList.splice(index, 1);
    },
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getClassCoursePeriodStatisticData();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getClassCoursePeriodStatisticData();
    },
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.selectTimeListTrueSearch = this.selectTimeListTrue;
      localStorage.setItem('selectTimeListTrue', JSON.stringify(this.selectTimeListTrue));
      this.getClassCoursePeriodStatisticData();
    },
    resetData() {
      this.selectTimeListTrue = [[]];
      this.formValidate.classTypeShow = [];
      this.formValidate.classData = [];
      this.handleSearch();
    },
    //  获取报名汇总数据
    async getClassCoursePeriodStatisticData() {
      const params = {
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
        schoolId: this.orgId
      };
      this.formValidate.classTypeShow && this.formValidate.classTypeShow.length > 0 ? params.courseTypeKinds = [this.formValidate.classTypeShow[1]] : '';
      this.formValidate.classData[0] ? params.gradeId = this.formValidate.classData[0] : '';
      this.formValidate.classData[1] ? params.classId = this.formValidate.classData[1] : '';

      if (this.yearTerms.length && this.yearTerms[1]) {
        params.yearCode = this.yearTerms[0];
        params.termCode = this.yearTerms[1];
      } else {
        params.yearCode = '';
        params.termCode = '';
      }
      if (this.courseTimes.length > 0) {
        params.courseTimes = this.courseTimes;
      }

      this.loading = true;
      this.pageInfo.total = 0;
      this.tableList = [];

      const res = await analysisCenterApi.queryClassCoursePeriodStatisticPageApi(params);
      this.loading = false;
      if (res.status === 200) {
        this.pageInfo.total = +res.message.total;
        this.tableList = res.message.list.map(item => {
          const { courseTimeInfoList, ...other } = item;
          const obj = {};
          courseTimeInfoList.forEach(x => {
            Object.keys(x.courseTimes).forEach(j => {
              obj[`${x.week}-${j}`] = x.courseTimes[j];
            });
          });
          return {
            ...other,
            ...this.timeColumnsKeyObj,
            ...obj
          };
        });
        const time = new Date();
        this.timeFont = formatTime(time, 'yyyy-MM-dd hh:mm:ss');
      }
    },

    handleOpenTimeModal() {
      this.selectTimeList = [...this.selectTimeListTrue];
      this.showClassTimeModal = true;
    },
    checkTimeSelect() {
      let tag = this.selectTimeList.some(item => {
        return item.length !== 2 || (item.length === 2 && (!item[0] || !item[1]));
      });
      if (tag) {
        this.$Message.error('请补全选择上课时间！');
        return;
      }
      const copyData = [...this.selectTimeList];
      for (let i = 0; i < this.selectTimeList.length; i++) {
        const originItem = copyData.splice(0, 1)[0];
        for (let x = 0; x < copyData.length; x++) {
          const compareItem = copyData[x];
          tag = checkTimeRangehasIntersection(originItem, compareItem);
          if (tag) {
            this.$Message.error(`第${i + 1}行 与 第${i + 1 + x + 1}行 的起止时间存在交叉！`);
            break;
          }
        }
        if (tag) {
          break;
        }
      }
      if (!tag) {
        this.selectTimeListTrue = [...this.selectTimeList];

        this.showClassTimeModal = false;
      }
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出-进度条
    handleCancelExport() {
      this.source.cancel('取消请求');
    },
    async handleDownload() {
      const params = {
        schoolId: this.orgId
      };
      this.formValidate.classTypeShow && this.formValidate.classTypeShow.length > 0 ? params.courseTypeKinds = this.formValidate.classTypeShow[1] : '';
      this.formValidate.classData[0] ? params.gradeId = this.formValidate.classData[0] : '';
      this.formValidate.classData[1] ? params.classId = this.formValidate.classData[1] : '';

      if (this.yearTerms.length && this.yearTerms[1]) {
        params.yearCode = this.yearTerms[0];
        params.termCode = this.yearTerms[1];
      } else {
        params.yearCode = '';
        params.termCode = '';
      }
      if (this.courseTimes.length > 0) {
        params.courseTimes = this.courseTimes;
      }
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const res = await analysisCenterApi.exportClassCoursePeriodStatisticPageApi(params, this.source.token);
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              this.courseTypeShow = false;
              this.modalShow = false;
              this.downloadSelectType = -1;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.showExportModal = false;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.cascader-select {
  width: 250px;
  line-height: 32px;
  /deep/.el-input--suffix {
    .el-input__inner {
      width: 100% !important;
      padding: 4px 7px;
      height: 32px!important;
      min-height: 32px!important;
      line-height: 1.5;
      vertical-align: top;
    }
  }
  /deep/.el-input__suffix {
    height: 32px;
    line-height: 32px;
    .el-input__suffix-inner {
      .el-icon-circle-close:before {
        content: '\e79d' !important;
        color:#808695;
        opacity: 0.6;
        vertical-align: middle;
      }
    }
  }
  /deep/.el-input__icon{
    line-height: 32px;
    &::before{
      color: #808695;
    }
    &::after{
      color: #808695;
    }
  }
}
.left-content{
  margin-top: 10px;
}
.time-select {
  .time-line{
    display: flex;
    align-items: center;
  }
}
.time-select+.time-select{
  margin-top: 16px;
}
.modal-footer{
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}
.select-time{
  height: 32px;
  border: 1px solid #dcdee2 ;
  border-radius: 4px;
  background: #fff;
  padding: 4px 7px;
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 32px;
  .right-icon-block{
    width: 30px;
    height: 30px;
    position: absolute;
    right: 2px;
    top: 0;
    padding-right: 5px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
  .close-icon{
    margin-left: 5px;
    display: none;
  }
  .arr-icon{
    margin-left: 5px;
    display: inline-block;
  }
  &:hover{
    cursor: pointer;
    .close-icon{
      display: inline-block;
    }
  }
}
.modal-content{
  display: flex;
  align-items: flex-start;
}
.time-select-modal{
  /deep/.ivu-modal-footer{
    border-top: none;
  }
}
</style>
